import { ecosystemStats } from "@/mocks/creatorDirectory";

const pillars = [
  {
    icon: "ri-film-line",
    title: "以中长视频见长",
    desc: "相比短平快的内容，这里更适合有完整叙事与信息量的作品。许多创作者会围绕一个主题做十几分钟甚至更长的深度输出，因此也更容易沉淀出有辨识度的个人风格。",
  },
  {
    icon: "ri-user-star-line",
    title: "创作者分层清晰",
    desc: "生态里既有稳定的头部大V，也有在细分领域深耕的优质达人，还有更新频率高、互动积极的潜力新人。不同梯队各有看点，适合不同需求的观众。",
  },
  {
    icon: "ri-compass-discover-line",
    title: "题材贴近生活",
    desc: "美食、三农、生活记录与知识科普是长期的表现主力，内容大多围绕真实生活展开，门槛低、代入感强，也更容易长期稳定地追下去。",
  },
];

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.05fr] lg:items-start lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-leaf-line"></i>
              平台生态速览
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              先看懂生态，再挑值得关注的人
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              西瓜视频是以中长视频为底色的内容社区，创作者围绕美食、三农、知识科普、生活记录等方向长期深耕。
              与追逐瞬时热点不同，这里的“网红”往往靠一个领域慢慢积累口碑，作品有完整的叙事和明确的信息量。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              理解生态的分层，能帮你更快地定位自己想看什么：想要完成度高、稳定输出的内容，看头部大V；
              想找垂直、具体的经验，看优质达人；想陪着账号一起成长，关注潜力新人最划算。
            </p>
            <p className="mt-6 rounded-lg border border-background-200 bg-background-100 px-4 py-3.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
              <i className="ri-information-line mr-1.5"></i>
              说明：本页为平台创作者生态的编辑视角梳理，用于帮助浏览与查找；账号的粉丝规模、更新节奏与排名都会随时间变化，具体以平台实时信息为准。
            </p>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 md:gap-4">
            {ecosystemStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/10 text-primary-600">
                  <i className={`${stat.icon} text-xl`}></i>
                </span>
                <p className="mt-4 font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                </p>
                <p className="mt-0.5 text-sm font-medium text-foreground-800">{stat.label}</p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{stat.note}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-3 md:gap-5">
          {pillars.map((pillar) => (
            <article
              key={pillar.title}
              className="rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500/12 text-accent-700">
                <i className={`${pillar.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {pillar.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{pillar.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}